const friendlyFormat = (num: number) => {
    return num.toLocaleString('en-US')
}

const toFixed = (num: number, decimalPlaces: number) => {
    return num.toFixed(decimalPlaces);
}

const round = (num: number, decimalPlaces: number = 2) => {
    const factor = Math.pow(10, decimalPlaces);
    const rounded = Math.round(num * factor) / factor;
    return rounded.toFixed(decimalPlaces);
}

const percentage = (num: number, decimalPlaces: number = 0): string => {
    const factor = Math.pow(10, decimalPlaces);
    return (Math.round(num * 100 * factor) / factor) + '%';
}

export const useNumber = () => {
    return {
        friendlyFormat,
        toFixed,
        round,
        percentage
    }
}
